import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import TextWithRichContent from 'components/TextWithRichContent';

import { sanitizeCommentHtml } from 'lib/comments/sanitizeCommentHtml';

const CommentBlockedMessage = dynamic(() => import('./CommentBlockedMessage'));

const CommentFixed = dynamic(() => import('./CommentFixed'));

/*
  Body virou um componente puro de conteúdo — só renderiza o texto do
  comentário (ou os placeholders de `commentFixed`/`isContentBlocked`).
  O Footer com ações (like/dislike/responder) foi tirado daqui e passou
  a ser renderizado pelo `Item.js` FORA do card cinza, pra replicar a
  separação visual do Pelando (reações flutuando sobre o fundo da
  aba, não dentro do bloco com bg).
*/
const CommentItemBody = ({
  commentFixed,
  commentStatusName,
  commentText,
  isContentBlocked,
  onShowCommentLinkClick,
}) => {
  if (commentFixed && !isContentBlocked) {
    return <CommentFixed commentText={commentText} />;
  }

  if (isContentBlocked) {
    return (
      <CommentBlockedMessage
        commentStatusName={commentStatusName}
        onShowCommentLinkClick={onShowCommentLinkClick}
      />
    );
  }

  return (
    <TextWithRichContent
      className="text-sm text-neutral-low-200 dark:text-neutral-high-100 md:text-base md:[&>img]:block"
      full
    >
      {sanitizeCommentHtml(commentText)}
    </TextWithRichContent>
  );
};

CommentItemBody.propTypes = {
  commentFixed: PropTypes.bool.isRequired,
  commentStatusName: PropTypes.string.isRequired,
  commentText: PropTypes.string.isRequired,
  isContentBlocked: PropTypes.bool.isRequired,
  onShowCommentLinkClick: PropTypes.func.isRequired,
};

export default CommentItemBody;
